import { useEffect, useState, useCallback } from "react";
import { useAppSelector, useAppDispatch, FilesyncLocalNotification, FilesyncLocalNotificationsMap, AsyncJobType } from "src/common";
import { driveActions } from "src/store";
import { RootState } from "src/store/configureStore";
import _ from "lodash";

//
export function useFSProcessNotification(notification_type: AsyncJobType, request_watch?: string) {
  const dispatch = useAppDispatch();
  const fs_notifications = useAppSelector((state: RootState) => state.drive.fs_notifications);
  const [new_notification, setNewNotification] = useState<FilesyncLocalNotification | undefined>();

  // Description: Update notifications
  useEffect(() => {
    processNotifications(fs_notifications);
  }, [fs_notifications]);

  // Description: Process notifications by type 
  // Check latest version and if the UI is already loading
  function processNotifications(_notification: FilesyncLocalNotificationsMap) {
    if (!!request_watch) {
      const _notification = _.has(fs_notifications, request_watch) ? fs_notifications[request_watch] : null;
      // NOTE: Match the notification type and request_id
      (!!_notification && _notification.type === notification_type) && setNewNotification(_notification);
    }
  }

  // Description: Reset hook for next set
  const resetNotifications = useCallback((remove_request_id: string) => {
    setNewNotification(undefined);
    // remove this notification from the store. 

    const _fs_notifications = _.omit(fs_notifications, remove_request_id);
    dispatch(driveActions.setLocalFSNotification(_fs_notifications));
  }, [dispatch, fs_notifications]);

  return {
    new_notification,
    resetNotifications
  };
}
